// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  min-height: 100vh;
}
body {
  margin: 0;
}
.nkl-deck-app-root-outer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.nkl-deck-app-root {
  padding-top: 50px;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root {
    padding-top: 0;
  }
}
.nkl-deck-app-root.nkl-deck-app-root-admin {
  padding-top: 100px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root.nkl-deck-app-root-admin {
    padding-top: 50px;
  }
}
.nkl-deck-app-root .ant-drawer-mask {
  z-index: 30;
}
.nkl-deck-app-root .nkl-content-root {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .nkl-content-root {
    padding-top: 100px;
  }
}
.nkl-deck-app-root .nkl-content-root .ant-layout-content {
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .nkl-content-root .ant-layout-content {
    margin: 0;
  }
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout {
  flex-direction: column;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content {
  padding-left: 320px;
  background-color: #F5F7FA;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer {
  z-index: 1001;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer:not(.main-drawer) {
  top: 100px;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer.ant-drawer-left .ant-drawer-body {
  padding-top: 0;
}
.nkl-deck-app-root .ant-layout-sider {
  animation-duration: 0s;
  overflow: auto;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .ant-layout-sider.open {
    z-index: 1002;
    top: 100px;
  }
  .nkl-deck-app-root .ant-layout-sider.collapsed {
    z-index: 1002;
    top: 100px;
  }
}
.nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.open {
  top: 100px;
}
.nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.collapsed {
  top: 100px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.open {
    top: 150px;
  }
  .nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.collapsed {
    top: 150px;
  }
}
@media screen and (max-width: 1407px) {
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content {
    padding-left: 0;
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider {
    height: 100%;
    position: fixed;
    box-shadow: 0px 16px 48px rgba(52, 56, 63, 0.24);
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider.collapsed {
    left: -320px;
    transition: left ease-in-out 300ms;
    box-shadow: none;
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider.open {
    left: 0;
  }
}
@media screen and (min-width: 1407px) {
  .nkl-deck-app-root .nkl-deck-site-content .ant-layout-sider {
    left: 0px;
    transition: left ease-in-out 300ms;
  }
}
.nkl-deck-app-root .ant-layout-sider {
  left: -320px;
  transition: left ease-in-out 300ms;
  position: fixed;
  z-index: 1002;
  top: 50px;
  height: 100%;
}
.nkl-deck-app-root.nkl-deck-no-header {
  padding-top: 0;
}
.nkl-deck-app-root.nkl-deck-no-header .nkl-deck-site-content {
  padding-left: 0;
}
.nkl-deck-app-root.antd-layout-has-sider {
  flex-direction: column;
}
.nkl-deck-app-root.nkl-deck-no-leftNav .ant-layout-content {
  margin-left: 0;
}
.nkl-deck-site-content {
  flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./src/deck/app-root/app-root.less"],"names":[],"mappings":"AAEA;;EAEI,iBAAA;AADJ;AAIA;EACI,SAAA;AAFJ;AAOA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AALJ;AAQA;EACI,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mKAAA;AANJ;AAQI;EAAA;IACI,cAAA;EALN;AACF;AAOI;EAEI,kBAAA;AANR;AAQQ;EAAA;IACI,iBAAA;EALV;AACF;AAZA;EAsBQ,WAAA;AAPR;AAfA;EA4BQ,iBAAA;EACA,kBAAA;EACA,mBAAA;AAVR;AAYQ;EAAA;IACI,kBAAA;EATV;AACF;AAzBA;EAqCY,SAAA;EACA,UAAA;AATZ;AAWY;EAAA;IACI,SAAA;EARd;AACF;AAYI;EACI,sBAAA;AAVR;AASI;EAIQ,mBAAA;EACA,yBAAA;AAVZ;AAKI;EAQY,aAAA;EACA,mKAAA;AAVhB;AAYgB;EACI,UAAA;AAVpB;AAagB;EAEQ,cAAA;AAZxB;AAnDA;EAuEQ,sBAAA;EACA,cAAA;AAjBR;AAmBQ;EACI;IACI,aAAA;IACA,UAAA;EAjBd;EAoBU;IACI,aAAA;IACA,UAAA;EAlBd;AACF;AAyBY;EACI,UAAA;AAvBhB;AA0BY;EACI,UAAA;AAxBhB;AA2BY;EACI;IACI,UAAA;EAzBlB;EA4Bc;IACI,UAAA;EA1BlB;AACF;AA+BI;EAGQ;IACI,eAAA;EA/Bd;EA6BM;IAMQ,YAAA;IACA,eAAA;IACA,gDAAA;EAhCd;EAwBM;IAYQ,YAAA;IACA,kCAAA;IACA,gBAAA;EAjCd;EAmBM;IAkBQ,OAAA;EAlCd;AACF;AAsCI;EAAA;IAGY,SAAA;IACA,kCAAA;EArCd;AACF;AAvGA;EAiJQ,YAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;AAvCR;AA4CI;EACI,cAAA;AA1CR;AAyCI;EAIQ,eAAA;AA1CZ;AA+CI;EACI,sBAAA;AA7CR;AAgDI;EAEQ,cAAA;AA/CZ;AAoDA;EACI,cAAA;AAlDJ","sourcesContent":["// @import '@nackle/origami/dist/css/ant-main.css';\n\nhtml,\nbody {\n    min-height: 100vh;\n}\n\nbody {\n    margin: 0;\n}\n\n// IE11 requires a container div to wrap the real container\n// with the same flex rules for a sticky footer to work.\n.nkl-deck-app-root-outer {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.nkl-deck-app-root {\n    padding-top: 50px;\n    display: flex;\n    min-height: 100vh;\n    flex-direction: column;\n    font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\n    @media screen and (max-width: 735px) {\n        padding-top: 0;\n    }\n\n    &.nkl-deck-app-root-admin {\n\n        padding-top: 100px;\n\n        @media screen and (max-width: 735px) {\n            padding-top: 50px;\n            ;\n        }\n    }\n\n    .ant-drawer-mask {\n        z-index: 30;\n    }\n\n    .nkl-content-root {\n        //TODO put this back when nackle tile is being used\n        // max-width: 1024px;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 24px;\n\n        @media screen and (max-width: 735px) {\n            padding-top: 100px;\n        }\n\n        .ant-layout-content {\n            margin: 0;\n            padding: 0;\n\n            @media screen and (max-width: 735px) {\n                margin: 0;\n            }\n        }\n    }\n\n    &.ant-layout-has-sider.ant-layout {\n        flex-direction: column;\n\n        .nkl-deck-site-content {\n            padding-left: 320px;\n            background-color: #F5F7FA;\n\n            .ant-drawer {\n                z-index: 1001;\n                font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\n                &:not(.main-drawer) {\n                    top: 100px;\n                }\n\n                &.ant-drawer-left {\n                    .ant-drawer-body {\n                        padding-top: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    .ant-layout-sider {\n        animation-duration: 0s;\n        overflow: auto;\n\n        @media screen and (max-width: 735px) {\n            &.open {\n                z-index: 1002;\n                top: 100px;\n            }\n\n            &.collapsed {\n                z-index: 1002;\n                top: 100px;\n            }\n        }\n    }\n\n    &.nkl-deck-app-root-admin {\n        .ant-layout-sider {\n\n            &.open {\n                top: 100px;\n            }\n\n            &.collapsed {\n                top: 100px;\n            }\n\n            @media screen and (max-width: 735px) {\n                &.open {\n                    top: 150px;\n                }\n\n                &.collapsed {\n                    top: 150px;\n                }\n            }\n        }\n    }\n\n    @media screen and (max-width: 1407px) {\n\n        &.ant-layout-has-sider.ant-layout {\n            & .nkl-deck-site-content {\n                padding-left: 0;\n            }\n\n            .ant-layout-sider {\n                height: 100%;\n                position: fixed;\n                box-shadow: 0px 16px 48px rgba(52, 56, 63, 0.24);\n            }\n\n            .ant-layout-sider.collapsed {\n                left: -320px;\n                transition: left ease-in-out 300ms;\n                box-shadow: none;\n            }\n\n            .ant-layout-sider.open {\n                left: 0;\n            }\n        }\n    }\n\n    @media screen and (min-width: 1407px) {\n        .nkl-deck-site-content {\n            .ant-layout-sider {\n                left: 0px;\n                transition: left ease-in-out 300ms;\n            }\n        }\n    }\n\n    .ant-layout-sider {\n        left: -320px;\n        transition: left ease-in-out 300ms;\n        position: fixed;\n        z-index: 1002;\n        top: 50px;\n        height: 100%;\n    }\n\n\n\n    &.nkl-deck-no-header {\n        padding-top: 0;\n\n        .nkl-deck-site-content {\n            padding-left: 0;\n        }\n    }\n\n    //NackleMenu: is inside a sider and changes the layout to column\n    &.antd-layout-has-sider {\n        flex-direction: column;\n    }\n\n    &.nkl-deck-no-leftNav {\n        .ant-layout-content {\n            margin-left: 0;\n        }\n    }\n}\n\n.nkl-deck-site-content {\n    flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
